import { ApplicantList } from '@/@types/LibraryComponent';

const applicants: Array<ApplicantList> = [
  {
    accountName: 'M.M',
    accountIconUrl: 'url',
    desiredPayment: 2000,
    scheduleUptime: 40,
    sideBusinessFlag: 1,
    scheduledJoinStartTime: '2020/11/01',
    occupation: 'エンジニア',
    jobName: 'プロトタイプ作成案件',
    status: '1',
    messageCount: 5,
  },
  {
    accountName: 'セオリー太郎',
    accountIconUrl: 'url',
    desiredPayment: 2000,
    scheduleUptime: 25,
    sideBusinessFlag: 1,
    scheduledJoinStartTime: '2020/11/01',
    occupation: 'エンジニア',
    jobName: 'プロトタイプ作成案件',
    status: '1',
    messageCount: 10,
  },
  {
    accountName: 'K.P',
    accountIconUrl: 'url',
    desiredPayment: 3500,
    scheduleUptime: 30,
    sideBusinessFlag: 1,
    scheduledJoinStartTime: '2020/11/01',
    occupation: 'エンジニア',
    jobName: 'プロトタイプ作成案件',
    status: '1',
    messageCount: 0,
  },
  {
    accountName: 'T.Y',
    accountIconUrl: 'url',
    desiredPayment: 3000,
    scheduleUptime: 35,
    sideBusinessFlag: 1,
    scheduledJoinStartTime: '2020/11/01',
    occupation: 'エンジニア',
    jobName: 'プロトタイプ作成案件',
    status: '1',
    messageCount: 3,
  },
  {
    accountName: 'A.W',
    accountIconUrl: 'url',
    desiredPayment: 1000,
    scheduleUptime: 40,
    sideBusinessFlag: 1,
    scheduledJoinStartTime: '2020/11/01',
    occupation: 'エンジニア',
    jobName: 'プロトタイプ作成案件',
    status: '1',
    messageCount: 0,
  },
];

export default applicants;
